// extracted by mini-css-extract-plugin
module.exports = {"violet":"PairRow_violet_2vVVh","pointer":"PairRow_pointer_FgOXy","maxWidth":"PairRow_maxWidth_3LG49"};